import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { ref, reactive } from 'vue';
import { validatePassword, jsMd5 } from '@/utils/index';
import { ElMessage, ElMessageBox } from 'element-plus';
import CommonForm from '@/components/CommonForm.vue';
import { post } from '@/api/srm/common/common';
import { useI18n } from 'vue-i18n';
const serviceID = 'ZFO_PO_SUPPLIER_SRV';
const eneitySet = 'vendor_contactsSet';
export default /*#__PURE__*/_defineComponent({
  __name: 'changePass',
  setup(__props, {
    expose: __expose
  }) {
    const {
      t
    } = useI18n();
    const innerIsShow = ref(false);
    const formRef = ref();
    const loading = ref(false);
    const formObj = reactive({
      schema: {
        properties: {
          Password: {
            type: 'string',
            title: t('pc-registerDetail-s0-10')
          },
          ConfirmPassword: {
            type: 'string',
            title: t('pc-registerDetail-s0-11')
          }
        }
      },
      formSchema: ['Password', 'ConfirmPassword'],
      formUiSchema: {
        Password: {
          span: 22,
          slot: true
        },
        ConfirmPassword: {
          span: 22,
          slot: true
        }
      },
      formData: {},
      itemInfoRules: {
        Password: [{
          required: true,
          validator: validatePassword,
          trigger: 'blur'
        }],
        ConfirmPassword: [{
          required: true,
          validator: validateConfirmPasword,
          trigger: 'blur'
        }]
      }
    });
    // 密码校验
    function validateConfirmPasword(rule, value) {
      const val = rule.cellValue || value || '';
      if (val === '') {
        return Promise.reject(new Error(t('pc-registerDetail-o-28')));
      }
      if (val !== formObj.formData.Password) {
        return Promise.reject(new Error(`${t('pc-registerDetail-o-29')}!`));
      }
      return Promise.resolve();
    }
    /**
     * @description: 验证
     * @return {*}
     */
    async function validateform() {
      const formValidate = await formRef.value.validateForm();
      return formValidate;
    }
    /**
     * @description: 弹窗
     * @return {*}
     */
    function open() {
      innerIsShow.value = true;
    }
    /**
     * @description:关闭
     * @return {*}
     */
    function handleClosed() {
      innerIsShow.value = false;
      formRef.value.resetFields();
    }
    /**
     * @description: 确认修改
     * @return {*}
     */
    async function handleConfirm() {
      const valid = await validateform();
      if (!valid) {
        return ElMessage.error(t('pc-registerDetail-o-39'));
      }
      ElMessageBox.confirm(t('pc-registerDetail-o-40'), t('msg-2'), {
        confirmButtonText: t('ops-ok'),
        cancelButtonText: t('ops-cancel'),
        type: 'info'
      }).then(() => {
        confirmChangePass();
      });
    }
    /**
     * @description: 保存
     * @return {*}
     */
    async function confirmChangePass() {
      loading.value = true;
      const mdPass = jsMd5(formObj.formData.Password);
      const supplierEntity = JSON.parse(localStorage.getItem('gys_cur_supplier_info'));
      const data = {
        Operation: 'ChangePassword',
        MobilePhone: supplierEntity.mobilePhone,
        Password: mdPass
      };
      const res = await post(serviceID, eneitySet, data).catch(e => {
        console.log(e);
        loading.value = false;
      });
      loading.value = false;
      if (res === undefined) {
        return ElMessage.error(t('pc-registerDetail-o-41'));
      } else {
        handleClosed();
        return ElMessage.success(t('pc-registerDetail-o-42'));
      }
    }
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        title: _ctx.$t('pc-layout-1'),
        modelValue: innerIsShow.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => innerIsShow.value = $event),
        width: "35%",
        modal: true,
        "close-on-click-modal": false,
        onClosed: handleClosed
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: handleClosed,
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('ops-cancel')), 1)]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleConfirm,
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('ops-save')), 1)]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(CommonForm, {
          ref_key: "formRef",
          ref: formRef,
          schema: formObj.schema,
          formSchema: formObj.formSchema,
          "form-ui-schema": formObj.formUiSchema,
          formData: formObj.formData,
          "label-mode": _ctx.labelMode,
          loading: loading.value,
          labelWidth: 120,
          rules: formObj.itemInfoRules
        }, {
          Password: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formObj.formData.Password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formObj.formData.Password = $event),
            type: "password",
            "show-password": "true",
            autocomplete: "off"
          }, null, 8, ["modelValue"])]),
          ConfirmPassword: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formObj.formData.ConfirmPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formObj.formData.ConfirmPassword = $event),
            type: "password",
            "show-password": "true",
            autocomplete: "off"
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["schema", "formSchema", "form-ui-schema", "formData", "label-mode", "loading", "rules"])]),
        _: 1
      }, 8, ["title", "modelValue"])]);
    };
  }
});